import {
  AdmissionOptionsInput,
  InstitutionTypeEnum,
  InstitutionsFilterInput,
  ProgramTypeInput,
  SearchByTypeInput,
  StudyOptionsInput
} from 'src/generated/graphql';
import { InstitutionsFilter } from '../models/institutions-filter';
import { PAGING_CONFIG } from 'src/app/features/institution/instution.constant';
import { isEmptyObject } from '../helpers/empty-object';

export class InstitutionsFilterMapper {
  static dto(filter: InstitutionsFilter): InstitutionsFilterInput {
    /* locations */
    const locations = (filter.locations || []).map((item) => item.name) as any[];

    /* programs */
    const programs = filter.programs?.map((item) => item?.name) as any[];

    /* isTwoYears */
    const isTwoYears =
      filter.searchByType?.isTwoYears === filter.searchByType?.isFourYears
        ? undefined
        : filter.searchByType?.isTwoYears;

    /* institutionType */
    const institutionType: InstitutionTypeEnum[] = [];
    if (filter.searchByType?.public) {
      institutionType.push(InstitutionTypeEnum.Public);
    }
    if (filter.searchByType?.privateForProfit) {
      institutionType.push(InstitutionTypeEnum.PrivateForProfit);
    }
    if (filter.searchByType?.privateNonProfit) {
      institutionType.push(InstitutionTypeEnum.PrivateNonProfit);
    }

    /* admissionType */
    let admissionType: AdmissionOptionsInput | undefined = {
      testScore: filter.searchByType?.admissionType?.testScore || undefined,
      transcript: filter.searchByType?.admissionType?.transcript || undefined
    };

    /* studyOptions */
    const studyOptions: StudyOptionsInput | undefined = {
      inPerson: filter.searchByType?.studyOptions?.inPerson || undefined,
      distance: filter.searchByType?.studyOptions?.distance || undefined
    };

    /* programType */
    const programType: ProgramTypeInput | undefined = {
      associate: filter.searchByType?.programType?.associate || undefined,
      certificate: filter.searchByType?.programType?.certificate || undefined,
      bachelors: filter.searchByType?.programType?.bachelors || undefined,
      masters: filter.searchByType?.programType?.masters || undefined
    };

    /* searchByType */
    const searchByType: SearchByTypeInput | undefined = {
      isTwoYears: isTwoYears,
      institutionType: !!institutionType?.length ? institutionType : undefined,
      admissionType: !isEmptyObject(admissionType) ? admissionType : undefined,
      programType: !isEmptyObject(programType) ? programType : undefined,
      studyOptions: !isEmptyObject(studyOptions) ? studyOptions : undefined
    };

    const input: InstitutionsFilterInput = {
      pagination: {
        offset: filter.pagination?.offset || 0,
        limit: filter.pagination?.limit || PAGING_CONFIG.config.itemsPerPage
      },
      sortBy: filter.sortBy,
      searchTerm: filter.searchTerm,
      locations: !!locations?.length ? locations : undefined,
      searchByType: !isEmptyObject(searchByType) ? searchByType : undefined,
      programs: !!programs?.length ? programs : undefined,
      acceptanceRate: filter.acceptanceRate || undefined,
      participantsNumber: filter.participantsNumber || undefined
    };
    return input;
  }
}
